module.exports = __webpack_public_path__ + "static/media/ricardo-perez-bumper_selected.f480cb9c.svg";